var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.505,
    height: 14.979,
    viewBox: "0 0 19.505 14.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5690",
    "data-name": "Group 5690",
    transform: "translate(-1.232 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29031",
    "data-name": "Path 29031",
    d: "M2.031,11.529a.909.909,0,0,1,0-.574,9.438,9.438,0,0,1,17.906,0,.9.9,0,0,1,0,.574,9.437,9.437,0,0,1-17.905,0Z",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29032",
    "data-name": "Path 29032",
    d: "M15,12a3,3,0,1,1-3-3A3,3,0,0,1,15,12Z",
    transform: "translate(-1.016 -0.761)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6277f657e41551c4d33da993783cf918.svg";
export { ForwardRef as ReactComponent };